import React from "react";
import { Link } from "react-router-dom";
import { Home, Frown, ArrowLeft } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div
      className="min-h-screen bg-background flex items-center justify-center p-6"
      data-testid="not-found-page"
    >
      <Card className="max-w-md w-full p-8 text-center space-y-5">
        <div className="w-16 h-16 mx-auto rounded-2xl bg-primary/10 text-primary flex items-center justify-center">
          <Frown className="w-8 h-8" />
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-widest text-muted-foreground font-bold">
            Erro 404
          </div>
          <h1 className="text-2xl font-bold tracking-tight mt-1">Página não encontrada</h1>
          <p className="text-sm text-muted-foreground mt-2">
            O endereço que você acessou não existe ou foi removido. Que tal voltar
            para a página inicial?
          </p>
        </div>
        <div className="flex gap-2 justify-center flex-wrap">
          <Button
            variant="outline"
            className="rounded-full gap-1"
            onClick={() => window.history.back()}
            data-testid="not-found-back"
          >
            <ArrowLeft className="w-4 h-4" /> Voltar
          </Button>
          <Link to="/">
            <Button className="rounded-full gap-1" data-testid="not-found-home">
              <Home className="w-4 h-4" /> Página inicial
            </Button>
          </Link>
        </div>
      </Card>
    </div>
  );
}
